(function () {
  /**
   * @ngdoc module
   * @name app.core.api.interceptor.ready
   * @description module that defines the apiInterceptorReady provider
   */
  angular.module('app.core.api.interceptor.ready', [
    'app.core.api.interceptor',
    'binky.core.api.ready',
    'binky.core.configuration.ready',
    'binky.core.lodash',
  ]);
})();
